export const cars =[
    {
        image: "/images/Hyunda_Tucson/1.jpg",
        // title: "Hyundai Tucson"
    },
    {
        image: "/images/Hyunda_Tucson/2.jpg",
        // title: "Hyundai Tucson"
    },
    {
        image: "/images/Hyunda_Tucson/3.jpg",
        // title: "Hyundai Tucson"
    },
    {
        image: "/images/Hyunda_Tucson/4.jpg",
        // title: "Hyundai Tucson"
    },
    {
        image: "/images/Hyunda_Tucson/5.jpg",
        // title: "Hyundai Tucson"
    }
];